import React from 'react'

export const FabButton = ({}) => {
  return (
    <div>
      FabButton
    </div>
  )
}